import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Qué incluye la implementación?',
  a: 'La implementación del servicio contratado, la configuración de las automatizaciones, las integraciones contempladas en el plan, el mantenimiento y soporte correspondientes, y la evolución del sistema según el plan.'
}, {
  q: '¿Qué costos externos existen?',
  a: 'Pueden existir costos externos según las herramientas que tu empresa decida usar: WhatsApp / Meta / API, número telefónico, Google Calendar, CRM premium, telefonía y consumo de IA o voz.'
}, {
  q: '¿Qué herramientas puede integrar ORIGEN?',
  a: 'WhatsApp, CRM, Google Calendar, formularios web, y APIs de terceros contempladas en el alcance del plan. Integraciones adicionales se cotizan por separado.'
}, {
  q: '¿Puedo contratar solo presencia digital?',
  a: 'Sí. Presencia Digital se contrata de forma independiente si tu prioridad es mejorar tu web y experiencia digital antes de automatizar procesos.'
}, {
  q: '¿VOICE puede transferir llamadas a una persona?',
  a: 'Sí. VOICE deriva la llamada a una persona del equipo cuando la situación lo requiere, después de identificar, entender y calificar al cliente.'
}, {
  q: '¿Qué pasa después de la implementación?',
  a: 'El sistema queda operando y damos soporte según el plan contratado. Los desarrollos o integraciones fuera del alcance contratado, así como los límites de uso y consumo, se definen según cada implementación.'
}];
function FAQItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-carbon/10" data-id="element-62" data-mp="1dgz20taenck4">
      <button onClick={() => setIsOpen(v => !v)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-4 py-5 text-left hover:opacity-70 transition-opacity duration-150" data-id="element-63" data-mp="1dfnymukvg6tj">
        <span className="font-display text-[15.5px] font-medium text-carbon" data-id="element-64" data-mp="25zcsu8xbpy9p">
          {q}
        </span>
        <ChevronDown size={16} className={`text-carbon/40 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-65" data-mp="2auff68vog2ap" />
      </button>
      <motion.div initial={false} animate={{
      height: isOpen ? 'auto' : 0
    }} transition={{
      duration: 0.22,
      ease: 'easeOut'
    }} className="overflow-hidden" data-id="element-66" data-mp="25xf6rrbcungf">
        <p className="font-body text-[14px] text-carbon/60 leading-[1.65] pb-5 max-w-[560px]" data-id="element-67" data-mp="1wwqtwzxp6t54">
          {a}
        </p>
      </motion.div>
    </div>;
}
export function FAQ() {
  return <section className="bg-arena pt-[100px] md:pt-[150px] pb-[64px] md:pb-[96px]" data-id="element-68" data-mp="1n549qe3dtjq8">
      <div className="max-w-[760px] mx-auto px-6 md:px-16" data-id="element-69" data-mp="1i72vq7ktcalm">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-10" data-id="element-70" data-mp="1e4o9relukuq4">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-71" data-mp="3ks5gqle4qhb8">
            PREGUNTAS FRECUENTES
          </span>
          <h2 className="font-display text-[26px] md:text-[34px] font-medium text-carbon" data-id="element-72" data-mp="3tu6bnblw4r9q">
            Antes de hablar con ORIGEN.
          </h2>
        </motion.div>

        <div className="border-t border-carbon/10" data-id="element-73" data-mp="321xe04ecdsvk">
          {faqs.map(item => <FAQItem key={item.q} q={item.q} a={item.a} data-id="element-74" data-mp="32049aunahiq7" />)}
        </div>
      </div>
    </section>;
}